import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [staffUser, setStaffUser] = useState(null);
  const [adminUser, setAdminUser] = useState(null);

  useEffect(() => {
    const st = localStorage.getItem('staff_token');
    const sd = localStorage.getItem('staff_user');
    if (st && sd) { try { setStaffUser(JSON.parse(sd)); } catch(e) {} }
    const at = localStorage.getItem('admin_token');
    const ad = localStorage.getItem('admin_user');
    if (at && ad) { try { setAdminUser(JSON.parse(ad)); } catch(e) {} }
  }, []);

  const staffLogin = (token, user) => {
    localStorage.setItem('staff_token', token);
    localStorage.setItem('staff_user', JSON.stringify(user));
    setStaffUser(user);
  };

  const adminLogin = (token, user) => {
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_user', JSON.stringify(user));
    setAdminUser(user);
  };

  const staffLogout = () => {
    localStorage.removeItem('staff_token');
    localStorage.removeItem('staff_user');
    setStaffUser(null);
  };

  const adminLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setAdminUser(null);
  };

  return (
    <AuthContext.Provider value={{ staffUser, adminUser, staffLogin, adminLogin, staffLogout, adminLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
